import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

type SaveDisbursementRowParams = {
    caseUUID: string;
    idUUID?: string;
    source: "provider" | "loan" | "insurance";
    sourcePartyId?: string | null;
    company: string;
    accountNumber?: string | null;
    type?: string;
    bill?: number;
    insurance?: number;
    adj?: number;
    self?: number;
    medPay?: number;
    currentBalance?: number;
    reduction?: number;
    sent?: string | null;
    approved?: string | null;
    sortOrder?: number;
};

export const useSaveDisbursementRowMutation = (): UseMutationResult<
    void,
    Error,
    SaveDisbursementRowParams
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ caseUUID, idUUID, ...attributes }) => {
            const url = idUUID ? apiUrl(`/disbursement/${idUUID}`) : apiUrl("/disbursement");

            const body = {
                caseUUID,
                ...attributes,
            };

            const response = await fetch(url, {
                method: idUUID ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async (_data, { caseUUID }) => {
            await queryClient.invalidateQueries({
                queryKey: ["disbursement", caseUUID],
            });
        },
    });
};
